let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kVX56"), load("76n7a"), load("l253H"), load("bET2R")]).then(() => parcelRequire('2NciN'));